import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CALYPSO } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIClickable from 'UIComponents/button/UIClickable';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import unescapedText from 'I18n/utils/unescapedText'; // @ts-expect-error module is untyped

import MainSection from 'ecosystem-marketplace-core/components/layout/MainSection';
import { validUnescapedText } from 'ecosystem-marketplace-core/i18n/utils';
import MobileBrowsePanel from './MobileBrowsePanel';
import { selectCollections } from '../../../slices/collections/collectionsSlice';

const stripTrailingSlash = path => {
  if (path === '/') return path;
  if (!path.endsWith('/')) return path;
  return path.slice(0, -1);
};

function BrowseTitle() {
  const location = useLocation();
  const collections = useSelector(selectCollections);
  const currentPath = stripTrailingSlash(location.pathname);
  const collection = collections.find(c => `/${c.publishedListing.slug}` === currentPath);
  const title = collection ? validUnescapedText(`marketplace-assets-ui.collections.collection_${collection.id}.title`, {}, collection.publishedListing.title) : unescapedText('marketplace-assets-ui.storefront.nav.themes');
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.storefront.nav.browse",
    options: {
      title
    }
  });
}

export default function MobileBrowseBar() {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const mobileBrowseBarRef = useRef(null);

  const handlePanelCloseComplete = () => {
    mobileBrowseBarRef.current.focus();
  };

  return /*#__PURE__*/_jsxs(MainSection, {
    className: "p-y-3",
    color: "light",
    responsive: true,
    children: [/*#__PURE__*/_jsx(UIClickable, {
      buttonRef: mobileBrowseBarRef,
      onClick: () => {
        setIsPanelOpen(true);
      },
      onKeyDown: event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          setIsPanelOpen(true);
        }
      },
      tabIndex: 0,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        children: [/*#__PURE__*/_jsx(BrowseTitle, {}), /*#__PURE__*/_jsx(UIIcon, {
          className: "m-left-auto",
          name: "right",
          color: CALYPSO,
          size: "xs"
        })]
      })
    }), /*#__PURE__*/_jsx(MobileBrowsePanel, {
      onClose: () => {
        setIsPanelOpen(false);
        handlePanelCloseComplete();
      },
      open: isPanelOpen
    })]
  });
}